import { render, staticRenderFns } from "./OrderStatsChart.vue?vue&type=template&id=6478be13&"
import script from "./OrderStatsChart.vue?vue&type=script&lang=js&"
export * from "./OrderStatsChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports